import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Image } from '../../interfaces/image';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-handover-image',
  templateUrl: './handover-image.component.html',
  styleUrls: ['./handover-image.component.scss'],
  standalone: false,
})
export class HandoverImageComponent implements OnInit {
  imageDialog: Image = {} as Image;
  titleDialog = '';
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;
  constructor(
    @Inject(MAT_DIALOG_DATA) public inputData: Record<string, unknown>
  ) {}

  ngOnInit(): void {
    if (this.inputData.image) {
      this.imageDialog = this.inputData.image as Image;
    }
    if (this.inputData.title) {
      this.titleDialog = this.inputData.title as string;
    }
  }
}
